import { useTranslation } from "react-i18next";
import LegalDocumentPage, {
  LegalSection,
} from "../components/legal/LegalDocumentPage";
import { WEB_URL } from "../constants";

const TermsOfService = () => {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      title: t("termsSectionAcceptanceTitle"),
      paragraphs: [t("termsSectionAcceptanceBody")],
    },
    {
      title: t("termsSectionBookingsTitle"),
      paragraphs: [t("termsSectionBookingsBody")],
      bullets: [
        t("termsSectionBookingsBullet1"),
        t("termsSectionBookingsBullet2"),
        t("termsSectionBookingsBullet3"),
      ],
    },
    {
      title: t("termsSectionPricingTitle"),
      paragraphs: [t("termsSectionPricingBody")],
    },
    {
      title: t("termsSectionChangesTitle"),
      paragraphs: [t("termsSectionChangesBody")],
    },
    {
      title: t("termsSectionResponsibilitiesTitle"),
      paragraphs: [t("termsSectionResponsibilitiesBody")],
      bullets: [
        t("termsSectionResponsibilitiesBullet1"),
        t("termsSectionResponsibilitiesBullet2"),
        t("termsSectionResponsibilitiesBullet3"),
      ],
    },
    {
      title: t("termsSectionLiabilityTitle"),
      paragraphs: [t("termsSectionLiabilityBody")],
    },
    {
      title: t("termsSectionUpdatesTitle"),
      paragraphs: [t("termsSectionUpdatesBody")],
    },
  ];

  return (
    <LegalDocumentPage
      title={t("termsOfServiceTitle")}
      lastUpdatedLabel={t("legalLastUpdated")}
      lastUpdatedValue={t("termsOfServiceLastUpdatedValue")}
      intro={[
        t("termsIntro1"),
        t("termsIntro2"),
      ]}
      sections={sections}
      contactTitle={t("legalContactTitle")}
      contactDescription={t("termsContactBody")}
      websiteLabel={t("legalWebsiteLabel")}
      websiteUrl={WEB_URL}
      phoneLabel={t("legalPhoneLabel")}
      phoneValue="626-968-2688 / 626-968-7100"
    />
  );
};

export default TermsOfService;
